// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-078086e8] .custom-input__extended .input-group .input-group-text {\n  background: #2DB782;\n  color: #fff;\n}\n[data-v-078086e8] .custom-error-extended p {\n  color: #000 !important;\n}", ""]);
// Exports
module.exports = exports;
